module.exports = __webpack_public_path__ + "img/logo.5e08e60d.png";